import http from '@/fetch/http'
import Vue from 'vue'
import * as types from '@/vuex/types'

const state = {
    //总题数
    AllIndex: 0, //当前题
    Index: 1, //当前子题
    IndexSub: 0, //所有试题
    exercisesList: [], //是否提交
    isSubmit: false, //提交按钮是否可用
    UploadButton: false, //是否显示loading
    showLoading: false, //是否测验截止
    isTimeOut: false, //章列表
    stampList: [], //线列表
    lineList: [], //学生是否答完题
    isFinshQue: false, //是否发送成绩
    isSendFlag: false, //区分考试时间到查看答案 和 发送成绩查看答案
    isWatchAnswerFlag: false, // 是否显示预加载页面
    isShowLoadPage: false, //检查会计分录输入是否为数字
    isCheckShuZi: false,
    studentAnswerRecord: [] // 学生答案记录
}

const actions = {
    /**
     * 根据测试试卷id查找试题列表
     * @param commit
     * @param examId
     */
    selectExercisesByExamId({commit}, param) {
        const res = param.examInfoData;
        if (res.msgCode == types.STATUS_OK) {
            if (res.data && res.data.canViewAnswer === true) {
                commit('SET_IS_WATCH_ANSWER_FLAG', true);
            } else {
                commit('SET_IS_WATCH_ANSWER_FLAG', false);
            }

            let newParam = {
                examId: param.examId,
                selectedIndex: param.selectedIndex,
                initFillingAnswer: this.initFillingAnswer,
                initSubFillingAnswer: this.initSubFillingAnswer,
                questionSort: res.data.questionSort
            }
            http.selectExercisesByExamId(newParam)
                .then(res => {
                    if (res.msgCode == types.STATUS_OK) {
                        //拼成试题序号 每个类型从1开始
                        let list = res.data;
                        let index = 0;
                        let index1 = 0;
                        let index2 = 0;
                        let index3 = 0;
                        let index4 = 0;
                        let index5 = 0;
                        let index6 = 0;
                        let index7 = 0;
                        let order = 0;
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].type == 1) {
                                list[i].index = index;
                                index++;
                            } else if (list[i].type == 2) {
                                list[i].index = index1;
                                index1++;
                            } else if (list[i].type == 3) {
                                list[i].index = index2;
                                index2++;
                            } else if (list[i].type == 4) {
                                list[i].index = index5;
                                index5++;
                            } else if (list[i].type == 5) {
                                list[i].index = index6;
                                index6++;
                            } else if (list[i].type == 6) {
                                if (list[i].subExerciseList.length > 0) {
                                    for (var n = 0; n < list[i].subExerciseList.length; n++) {
                                        // 子分录
                                        if (list[i].subExerciseList[n].type == 8) {
                                            if (list[i].subExerciseList[n].accountRecordSubExercise.length > 0) {
                                                // 分录-子题
                                                for (var x = 0; x < list[i].subExerciseList[n].accountRecordSubExercise.length; x++) {
                                                    // 学生答题
                                                    if (list[i].subExerciseList[n].accountRecordSubExercise[x].studentAnswerList.length > 0) {
                                                        for (var j = 0; j < list[i].subExerciseList[n].accountRecordSubExercise[x].studentAnswerList.length; j++) {
                                                            var arAnswerList = list[i].subExerciseList[n].accountRecordSubExercise[x].studentAnswerList[j];
                                                            if (arAnswerList.length > 0) {
                                                                // 处理分录题数据（accountType为1：需要显示主帐科目，2：不需要显示））
                                                                var ledgerAccountOne = '';
                                                                var ledgerAccountTwo = '';
                                                                var isFirstBorrow = true;
                                                                var isFirstLend = true;
                                                                for (var k = 0; k < arAnswerList.length; k++) {
                                                                    var stuAnswerObj = arAnswerList[k];
                                                                    if (stuAnswerObj.borrowLend == '1') {
                                                                        if (isFirstBorrow) {
                                                                            ledgerAccountOne = stuAnswerObj.ledgerAccount;
                                                                            stuAnswerObj.accountType = 1;
                                                                            isFirstBorrow = false;
                                                                            // 学生作答描述（遇到第一个借时设置）
                                                                            list[i].subExerciseList[n].accountRecordSubExercise[x].studentAnswerList[j].groupDescription = stuAnswerObj.groupDescription;
                                                                            continue;
                                                                        }
                                                                        if (ledgerAccountOne != stuAnswerObj.ledgerAccount) {
                                                                            stuAnswerObj.accountType = 1;
                                                                            ledgerAccountOne = stuAnswerObj.ledgerAccount;
                                                                            isFirstBorrow = false;
                                                                        } else {
                                                                            stuAnswerObj.accountType = 2;
                                                                        }
                                                                    }
                                                                    if (stuAnswerObj.borrowLend == '2') {
                                                                        if (isFirstLend) {
                                                                            ledgerAccountTwo = stuAnswerObj.ledgerAccount;
                                                                            stuAnswerObj.accountType = 1;
                                                                            isFirstLend = false;
                                                                            continue;
                                                                        }
                                                                        if (ledgerAccountTwo != stuAnswerObj.ledgerAccount) {
                                                                            stuAnswerObj.accountType = 1;
                                                                            ledgerAccountTwo = stuAnswerObj.ledgerAccount;
                                                                            isFirstBorrow = false;
                                                                        } else {
                                                                            stuAnswerObj.accountType = 2;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    // 正确答案
                                                    if (list[i].subExerciseList[n].accountRecordSubExercise[x].answerList.length > 0) {
                                                        for (var a = 0; a < list[i].subExerciseList[n].accountRecordSubExercise[x].answerList.length; a++) {
                                                            if (list[i].subExerciseList[n].accountRecordSubExercise[x].answerList[a].length > 0) {
                                                                // 判断总账科目显示accountType
                                                                var ledgerOne = '';
                                                                var ledgerTwo = '';
                                                                for (var b = 0; b < list[i].subExerciseList[n].accountRecordSubExercise[x].answerList[a].length; b++) {
                                                                    var answerObj = list[i].subExerciseList[n].accountRecordSubExercise[x].answerList[a][b];
                                                                    if (answerObj.borrowLend == '1') {
                                                                        if (ledgerOne != answerObj.ledgerAccount) {
                                                                            answerObj.accountType = 1;
                                                                            ledgerOne = answerObj.ledgerAccount;
                                                                        } else {
                                                                            answerObj.accountType = 2;
                                                                        }
                                                                    }
                                                                    if (answerObj.borrowLend == '2') {
                                                                        if (ledgerTwo != answerObj.ledgerAccount) {
                                                                            answerObj.accountType = 1;
                                                                            ledgerTwo = answerObj.ledgerAccount;
                                                                        } else {
                                                                            answerObj.accountType = 2;
                                                                        }
                                                                    }
                                                                    // 正确答案描述
                                                                    list[i].subExerciseList[n].accountRecordSubExercise[x].answerList[a].groupDescription = answerObj.groupDescription;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                list[i].index = index7;
                                //设置子题总题数
                                index7++
                            } else if (list[i].type == 9) {
                                list[i].index = index3;
                                index3++;
                            } else if (list[i].type == 8) {
                                if (list[i].accountRecordSubExercise.length > 0) {
                                    for (var x = 0; x < list[i].accountRecordSubExercise.length; x++) {
                                        // 学生答题
                                        if (list[i].accountRecordSubExercise[x].studentAnswerList.length > 0) {
                                            for (var j = 0; j < list[i].accountRecordSubExercise[x].studentAnswerList.length; j++) {
                                                var arAnswerList = list[i].accountRecordSubExercise[x].studentAnswerList[j];
                                                if (arAnswerList.length > 0) {
                                                    // 处理分录题数据（accountType为1：需要显示主帐科目，2：不需要显示））
                                                    var ledgerAccountOne = '';
                                                    var ledgerAccountTwo = '';
                                                    var isFirstBorrow = true;
                                                    var isFirstLend = true;
                                                    for (var k = 0; k < arAnswerList.length; k++) {
                                                        var stuAnswerObj = arAnswerList[k];
                                                        if (stuAnswerObj.borrowLend == '1') {
                                                            if (isFirstBorrow) {
                                                                ledgerAccountOne = stuAnswerObj.ledgerAccount;
                                                                stuAnswerObj.accountType = 1;
                                                                isFirstBorrow = false;
                                                                // 学生作答描述（遇到第一个借时设置）
                                                                list[i].accountRecordSubExercise[x].studentAnswerList[j].groupDescription = stuAnswerObj.groupDescription;
                                                                continue;
                                                            }
                                                            if (ledgerAccountOne != stuAnswerObj.ledgerAccount) {
                                                                stuAnswerObj.accountType = 1;
                                                                ledgerAccountOne = stuAnswerObj.ledgerAccount;
                                                                isFirstBorrow = false;
                                                            } else {
                                                                stuAnswerObj.accountType = 2;
                                                            }
                                                        }
                                                        if (stuAnswerObj.borrowLend == '2') {
                                                            if (isFirstLend) {
                                                                ledgerAccountTwo = stuAnswerObj.ledgerAccount;
                                                                stuAnswerObj.accountType = 1;
                                                                isFirstLend = false;
                                                                continue;
                                                            }
                                                            if (ledgerAccountTwo != stuAnswerObj.ledgerAccount) {
                                                                stuAnswerObj.accountType = 1;
                                                                ledgerAccountTwo = stuAnswerObj.ledgerAccount;
                                                                isFirstBorrow = false;
                                                            } else {
                                                                stuAnswerObj.accountType = 2;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // 正确答案
                                        if (list[i].accountRecordSubExercise[x].answerList.length > 0) {
                                            for (var a = 0; a < list[i].accountRecordSubExercise[x].answerList.length; a++) {
                                                if (list[i].accountRecordSubExercise[x].answerList[a].length > 0) {
                                                    // 判断总账科目显示accountType
                                                    var ledgerOne = '';
                                                    var ledgerTwo = '';
                                                    for (var b = 0; b < list[i].accountRecordSubExercise[x].answerList[a].length; b++) {
                                                        var answerObj = list[i].accountRecordSubExercise[x].answerList[a][b];
                                                        if (answerObj.borrowLend == '1') {
                                                            if (ledgerOne != answerObj.ledgerAccount) {
                                                                answerObj.accountType = 1;
                                                                ledgerOne = answerObj.ledgerAccount;
                                                            } else {
                                                                answerObj.accountType = 2;
                                                            }
                                                        }
                                                        if (answerObj.borrowLend == '2') {
                                                            if (ledgerTwo != answerObj.ledgerAccount) {
                                                                answerObj.accountType = 1;
                                                                ledgerTwo = answerObj.ledgerAccount;
                                                            } else {
                                                                answerObj.accountType = 2;
                                                            }
                                                        }
                                                        // 正确答案描述
                                                        list[i].accountRecordSubExercise[x].answerList[a].groupDescription = answerObj.groupDescription;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                list[i].index = index4;
                                index4++;
                            }
                        }
                        //关闭loading
                        commit('SET_SHOW_LOADING', false);
                        //关闭预加载页面
                        commit('SET_SHOW_LOAD_PAGE', false)
                        // debugger
                        //试题列表赋值
                        commit('SET_EXERCISES_LIST', list);
                        //设置总题数
                        commit('SET_ALLINDEX', res.data.length);
                        //设置初始化题数
                        if (res.data.length > 0) {
                            if (param.selectedIndex) {
                                commit('SET_INDEX', parseInt(param.selectedIndex));
                                if (list[param.selectedIndex - 1].type == 4) {
                                    param.initFillingAnswer(list[param.selectedIndex - 1].question);
                                }
                                // 如果第一道题是综合题 并且第一道是填空题，初始化题目和答案
                                if (list && list[param.selectedIndex - 1] && list[param.selectedIndex - 1].type == 6 && list[param.selectedIndex - 1].subExerciseList[0].type == 4) {
                                    param.initSubFillingAnswer(list[param.selectedIndex - 1].subExerciseList[0].question);
                                }
                            } else {
                                commit('SET_INDEX', 1);
                                // 如果第一道题是填空，初始化题目和答案
                                if (list && list[0] && list[0].type == 4) {
                                    param.initFillingAnswer(list[0].question);
                                }
                                // 如果第一道题是综合题 并且第一道是填空题，初始化题目和答案
                                if (list && list[0] && list[0].type == 6 && list[0].subExerciseList[0].type == 4) {
                                    param.initSubFillingAnswer(list[0].subExerciseList[0].question);
                                }
                            }
                        }
                        //判断是否只有一道题提交按钮
                        if (res.data.length == 1 && res.data[0].type != 6 || res.data[0].type == 6 && res.data[0].subExerciseList.length == 1 && res.data.length == 1) {
                            commit('SET_IS_FINSH_QUE', true);
                        }
                    } else {
                    }
                })
                .catch(error => {
                    console.error(error);
                })
        }
    },

    /**
     * 查找章和线的列表
     * @param commit
     * @param exercisesId
     */
    selectStampAndLine({commit}, exercisesId) {
        http.findBillSigns({exercisesId: exercisesId})
            .then(res => {
                commit('SET_STAMP_LIST', res.data);
            })
            .catch(error => {
            })
        http.findBillLine({exercisesId: exercisesId})
            .then(res => {
                commit('SET_LINE_LIST', res.data);
            })
            .catch(error => {
            })
    }, setShowLoadPage({commit}, param) {
        commit('SET_SHOW_LOAD_PAGE', param);
    }, setShowLoading({commit}, param) {
        commit('SET_SHOW_LOADING', param);
    }, setIndex({commit}, index) {
        commit('SET_INDEX', index);
    }, setIndexSub({commit}, indexSub) {
        commit('SET_INDEXSUB', indexSub);
    }, setUploadButton({commit}, flag) {
        commit('SET_UPLOAD_BUTTON', flag);
    }, setIsSubmit({commit}, flag) {
        commit('SET_IS_SUBMIT', flag);
    }, setIsTimeOut({commit}, status) {
        commit('SET_IS_TIME_OUT', status);
    }, setIsFinshQue({commit}, flag) {
        commit('SET_IS_FINSH_QUE', flag)
    }, setIsSendFlag({commit}, flag) {
        commit('SET_IS_SEND_FLAG', flag)
    }, setIsWatchAnswerFlag({commit}, flag) {
        commit('SET_IS_WATCH_ANSWER_FLAG', flag)
    }, setIsCheckShuZi({commit}, flag) {
        commit('SET_IS_CHECK_SHU_ZI', flag)
    }, setStudentAnswerRecord({commit}, value) {
        commit('SET_STUDENT_ANSWER_RECORD', value)
    },clearStudentAnswerRecord({commit}) {
        commit('CLEAR_STUDENT_ANSWER_RECORD')
    }
}

const getters = {}

const mutations = {
    ['SET_STAMP_LIST'](state, list) {
        Vue.set(state, 'stampList', list);
    }, ['SET_LINE_LIST'](state, list) {
        Vue.set(state, 'lineList', list);
    }, ['SET_IS_TIME_OUT'](state, status) {
        Vue.set(state, 'isTimeOut', status);
    }, ['SET_IS_SUBMIT'](state, status) {
        Vue.set(state, 'isSubmit', status);
    }, ['SET_IS_FINSH_QUE'](state, status) {
        Vue.set(state, 'isFinshQue', status);
    }, ['SET_SHOW_LOADING'](state, status) {
        Vue.set(state, 'showLoading', status);
    }, ['SET_SHOW_LOAD_PAGE'](state, status) {
        Vue.set(state, 'showLoadPage', status)
    }, ['SET_EXERCISES_LIST'](state, list) {
        Vue.set(state, 'exercisesList', list);
    }, ['SET_INDEX'](state, index) {
        Vue.set(state, 'Index', index);
    }, ['SET_INDEXSUB'](state, indexSub) {
        Vue.set(state, 'IndexSub', indexSub);
    }, ['SET_ALLINDEX'](state, AllIndex) {
        Vue.set(state, 'AllIndex', AllIndex);
    }, ['SET_UPLOAD_BUTTON'](state, flag) {
        Vue.set(state, 'UploadButton', flag);
    }, ['SET_IS_SEND_FLAG'](state, status) {
        Vue.set(state, 'isSendFlag', status);
    }, ['SET_IS_WATCH_ANSWER_FLAG'](state, status) {
        Vue.set(state, 'isWatchAnswerFlag', status)
    }, ['SET_IS_CHECK_SHU_ZI'](state, status) {
        Vue.set(state, 'isCheckShuZi', status)
    }, ['SET_STUDENT_ANSWER_RECORD'](state, value) {
        state.studentAnswerRecord.push(value)
        Vue.set(state, 'studentAnswerRecord', state.studentAnswerRecord)
    }, ['CLEAR_STUDENT_ANSWER_RECORD']() {
        state.studentAnswerRecord = [];
        Vue.set(state, 'studentAnswerRecord', state.studentAnswerRecord)
    }
}

export default {
    state, actions, getters, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/student/answerquestion.js